import type { ReactNode } from 'react';
import type { CameraFacing } from '@/lib/camera.js';
import { Icon } from '@/ui/icons.js';

/**
 * Single icon button, like the camera app: one control that shows which way it
 * will flip rather than two labelled states. The arrows reverse direction with
 * the active lens so the button still says something without any text.
 */
export function CameraFlipButton({
  facing,
  onFlip,
  disabled,
}: {
  facing: CameraFacing;
  onFlip(): void;
  disabled?: boolean;
}): ReactNode {
  const front = facing === 'user';
  return (
    <button
      type="button"
      onClick={onFlip}
      disabled={disabled}
      aria-label={front ? 'Switch to rear camera' : 'Switch to front camera'}
      title={front ? 'Front camera' : 'Rear camera'}
      className="grid size-11 place-items-center rounded-full bg-white/20 text-white backdrop-blur transition active:scale-95 disabled:opacity-40"
    >
      <Icon
        name="flipCamera"
        size={24}
        style={{ transform: front ? 'scaleX(-1)' : 'none' }}
      />
    </button>
  );
}
